import CryptoJS from "crypto-js";
import config  from "../../config/config";

export const decryptData = (encryptedData: string) => {
    try {
        const key = CryptoJS.enc.Utf8.parse(config.decryptDataResponse.trim()); // Eliminamos espacios extras

        // 🔹 Convertir Base64 a WordArray
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData);

        // 🔹 Extraer IV (primeros 16 bytes) y el texto cifrado (resto de los bytes)
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4)); // 16 bytes
        const ciphertext = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4)); // Datos cifrados

        // 🔹 Crear CipherParams válidos
        const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext });

        // 🔹 Desencriptar con AES-256-CBC
        const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        // 🔹 Convertir a string UTF-8
        const result = decrypted.toString(CryptoJS.enc.Utf8);
        if (!result) throw new Error("Error al convertir los datos desencriptados.");

        return JSON.parse(result);
    } catch (error) {
        console.error("Error al desencriptar:", error);
        return null;
    }
}

export const getCardTypeByBin = (bin:string) => {
  if (/^4/.test(bin)) return 'VS';
  if (/^5[1-5]/.test(bin)) return 'MC';
  if (/^3[47]/.test(bin)) return 'AM';
  if (/^3(?:0[0-5]|[68])/.test(bin)) return 'DC';;
  return 'unknown';
};

export const timestampToDate = (timestamp: any): string => {
  timestamp = parseInt(timestamp);
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString('es-ES');
};



